import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/salesContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-ink-800 py-16 sm:py-24" aria-labelledby="faq-title" style={{
    paddingBottom: "0px"
  }} data-id="element-68" data-mp="1bmlievk97beo">
      <div className="mx-auto max-w-2xl px-5" data-id="element-69" data-mp="249g3nuowaet7">
        <h2 id="faq-title" className="text-center font-display text-3xl font-bold text-white sm:text-[2.5rem]" data-id="element-70" data-mp="24ahi8954djfo">
          ❓ Common Questions
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-71" data-mp="1ujmqip93trmu">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-ink-700" data-id="element-72" data-mp="1zhobjfq3c10y" data-mpi={i}>
                <h3 data-id="element-73" data-mp="2n70sj1rntddt">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-74" data-mp="2n6h7hc6pq8vk">
                    <span className="font-display text-lg font-bold text-white" data-id="element-75" data-mp="14t7ib3sa8lsw">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-lilac-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-76" data-mp="1eldb2fqcz795" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-77" data-mp="1ohyljgl5dakd">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-78" data-mp="1jkpx4y9eoaao">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-body" data-id="element-79" data-mp="3ud196eh3z5tj">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}